import type { FC } from "react"

import { ConfirmationDialog } from "@/components/common/Modals"

interface CompanyDuplicateConfirmationDialogProps {
  confirmLabel: string
  onClose: () => void
  onConfirm: () => void
}

export const CompanyDuplicateConfirmationDialog: FC<CompanyDuplicateConfirmationDialogProps> = ({
  confirmLabel,
  onClose,
  onConfirm,
}) => (
  <ConfirmationDialog
    title='Duplicate Company Name'
    content='Another company shares this name. Are you sure you want to create a duplicate?'
    closeLabel='Cancel'
    confirmLabel={confirmLabel}
    onClose={onClose}
    onConfirm={onConfirm}
  />
)
